import Sprite from './sprite';
import { Graphics } from 'pixi.js';
import { BLEND_MODES } from 'pixi.js';
import Position from './position';
import VectorTools from './vectorTools';

/**
 * 
 */
export default class SpriteSolidMask extends Sprite {

	/**
	 * PIXI graphics object for rendering 'invisible' solid polygons to be used as simple masks.
	 * automatically uses system.display.bgColor for fills
	 * @param {Object} args
	 * @param {String} args.layer name of layer within current scene to be added to, defaults to 'default'
	 * @param {Position} args.position starting position
	 * @param {Number} args.color override default bgColor, for testing only, looks awful!
	 * @param {*} args.shape string or array of strings describing continuous lines of space-separated x y coords, eg. ['0 0 50 0 50 250 0 250','0 0 10 0 10 10 0 10']
	 */
	constructor(args) {
		super(args);
	}

	init(entity) {
		super.init(entity);

		let args = this._args;

		this.position = args.position;
		this.color = args.color || this.system.palette.bg;
		
		// PIXI display object
		this.g = new Graphics();
		this.g.blendMode = BLEND_MODES.NORMAL;
		this.g.lineStyle(0);
		this.g.eventMode = 'none';
		this.layerName = args.layer || 'default';
		this.layer = this.scene.layers[this.layerName];
		this.layer.container.addChild(this.g);

		// setup polygon verts
		if(args.shape) {
			if(typeof args.shape == 'string') args.shape = [args.shape];
			this.paths = VectorTools.get().generatePathsFromShape(this._args);
		}
		
		this.redrawGraphics();
	}

	update(delta, deltaNormal) {
		super.update(delta, deltaNormal);
		
		// simple sprite transform update
		this.g.x = this.position.x;
		this.g.y = this.position.y;
		this.g.rotation = this.position.rotation;
		this.g.scale.set(this.position.scale);

		// perhaps second path in a shape could descibe a hole?
		// g.beginHole() ???
		// g.endHole() ???
	}

	redrawGraphics() {
		this.g.clear();
		// draw around vertices within all sub-paths
		for(let verts of this.paths) {
			// pen-up to start
			this.g.moveTo(verts[0][0], verts[0][1]);
			this.g.beginFill(this.color);
			// draw around all vertices in this sub-path
			for(let v=1; v<verts.length; v++) {
				this.g.lineTo(verts[v][0], verts[v][1]);
			}
			this.g.endFill();
		}
	}

	destroy() {
		this.layer.container.removeChild(this.g);
	}

}